package ru.dinarastepina.fabvocab.web.theme

import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.Color

// Direct color constants matching the shared mobile theme
val Indigo50: CSSColorValue = Color("#EEF2FF")
val Indigo100: CSSColorValue = Color("#E0E7FF")
val Indigo200: CSSColorValue = Color("#C7D2FE")
val Indigo300: CSSColorValue = Color("#A5B4FC")
val Indigo400: CSSColorValue = Color("#818CF8")
val Indigo500: CSSColorValue = Color("#6366F1")
val Indigo600: CSSColorValue = Color("#4F46E5")
val Indigo700: CSSColorValue = Color("#4338CA")
val Indigo800: CSSColorValue = Color("#3730A3")
val Indigo900: CSSColorValue = Color("#312E81")

val Slate50: CSSColorValue = Color("#F8FAFC")
val Slate100: CSSColorValue = Color("#F1F5F9")
val Slate200: CSSColorValue = Color("#E2E8F0")
val Slate300: CSSColorValue = Color("#CBD5E1")
val Slate400: CSSColorValue = Color("#94A3B8")
val Slate500: CSSColorValue = Color("#64748B")
val Slate600: CSSColorValue = Color("#475569")
val Slate700: CSSColorValue = Color("#334155")
val Slate800: CSSColorValue = Color("#1E293B")
val Slate900: CSSColorValue = Color("#0F172A")

val Emerald50: CSSColorValue = Color("#ECFDF5")
val Emerald100: CSSColorValue = Color("#D1FAE5")
val Emerald200: CSSColorValue = Color("#A7F3D0")
val Emerald300: CSSColorValue = Color("#6EE7B7")
val Emerald400: CSSColorValue = Color("#34D399")
val Emerald500: CSSColorValue = Color("#10B981")
val Emerald600: CSSColorValue = Color("#059669")

val Rose50: CSSColorValue = Color("#FFF1F2")
val Rose100: CSSColorValue = Color("#FFE4E6")
val Rose200: CSSColorValue = Color("#FECDD3")
val Rose300: CSSColorValue = Color("#FDA4AF")
val Rose400: CSSColorValue = Color("#FB7185")
val Rose500: CSSColorValue = Color("#F43F5E")
val Rose600: CSSColorValue = Color("#E11D48")
val Rose700: CSSColorValue = Color("#BE123C")
val Rose800: CSSColorValue = Color("#9F1239")
val Rose900: CSSColorValue = Color("#881337")

val Amber50: CSSColorValue = Color("#FFFBEB")
val Amber100: CSSColorValue = Color("#FEF3C7")
val Amber200: CSSColorValue = Color("#FDE68A")
val Amber300: CSSColorValue = Color("#FCD34D")
val Amber400: CSSColorValue = Color("#FBBF24")
val Amber500: CSSColorValue = Color("#F59E0B")
val Amber600: CSSColorValue = Color("#D97706")

val Success = Emerald500
val OnSuccess = Color("#FFFFFF")
val Warning = Amber500
val OnWarning = Color("#FFFFFF")
